import { FC, ReactNode } from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import { Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.tooltip.background,
    color: theme.palette.common.white,
    borderRadius: 4,
    padding: '2px 12px',
  },
}));

interface Props {
  children: ReactNode;
  title: ReactNode;
  disabled?: boolean;
  placement?:
    | 'top'
    | 'bottom'
    | 'right'
    | 'left'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'right-start'
    | 'right-end'
    | 'left-start'
    | 'left-end'
    | undefined;
}

const Tooltip: FC<Props> = ({ children, disabled = false, title, placement = 'top' }) => {
  const styles = useStyles();

  if (disabled) {
    return children;
  }

  return (
    <MuiTooltip
      title={title}
      placement={placement}
      slotProps={{ tooltip: { className: styles.tooltip } }}
    >
      <span>{children}</span>
    </MuiTooltip>
  );
};

export default Tooltip;
